/**
 * Release Channel Constants
 * Single source of truth for Public Beta labeling
 */

export const RELEASE_CHANNEL = "Public Beta V2.0";
export const RELEASE_NOTE = "Features are actively evolving. Feedback welcome.";
export const RELEASE_SUPPORT_NOTICE = "You're using the Public Beta of Man & Machine.";

// Support ID field names (from /api/auth/me)
export const SUPPORT_ID_FIELDS = {
  USER_ID: 'id',           // user.id (NOT user._id)
  ORG_ID: 'organization_id' // user.organization_id
};
